/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vehicle_Action_Archive_Reason_LabelInputs */

const fr_vehicle_action_archive_reason_label = /** @type {(inputs: Vehicle_Action_Archive_Reason_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Raison de l'archivage`)
};

const en_vehicle_action_archive_reason_label = /** @type {(inputs: Vehicle_Action_Archive_Reason_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archive reason`)
};

/**
* | output |
* | --- |
* | "Archive reason" |
*
* @param {Vehicle_Action_Archive_Reason_LabelInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const vehicle_action_archive_reason_label = /** @type {((inputs?: Vehicle_Action_Archive_Reason_LabelInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_Action_Archive_Reason_LabelInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_vehicle_action_archive_reason_label(inputs)
	return en_vehicle_action_archive_reason_label(inputs)
});